import { Plugin } from 'vue'
import Permissions from './permissions'

declare module 'vue' {
  interface ComponentCustomProperties {
    $permissions: Permissions
  }
}

export default {
  install(app) {
    app.config.globalProperties.$permissions = new Permissions()
  },
} as Plugin
